<script setup lang="ts">
import { getUrl } from '@/lib/helpers'

const siteName = 'CSM - Centrum Szkolenia Muzyków i Liderów Uwielbienia'
const siteDesc = 'Misja CSM to różnorodne działania mające na celu rozwój służby uwielbienia w Polsce.'
const siteUrl = getUrl()
const siteImage = getUrl('/opengraph.jpg')

useHead({
  htmlAttrs: { lang: 'pl' },
  titleTemplate(title) {
    if (!title) return siteName
    return title === siteName ? title : `${title} | ${siteName}`
  },
})

useSeoMeta({
  description: siteDesc,
  ogTitle: siteName,
  ogDescription: siteDesc,
  ogType: 'website',
  ogUrl: siteUrl,
  ogImage: siteImage,
  ogLocale: 'pl_PL',
  twitterCard: 'summary_large_image',
  twitterTitle: siteName,
  twitterDescription: siteDesc,
  twitterImage: siteImage,
})

const webSiteSchema = computed(() => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteName,
  url: siteUrl,
}))

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(webSiteSchema.value),
    },
  ],
})
</script>

<template>
  <v-app>
    <ui-navbar />
    <v-main>
      <router-view />
    </v-main>
    <ui-footer />
  </v-app>
</template>
